import appService from '../js/appservice/index'
import { getErrorMessage } from '../js/helpers/axioshelper'

const state = {
  tests: []
}

const getters = { tests: state => state.tests }

const actions = {
  updateTestSuiteExpireDate(context, testSuite) {
    return new Promise((resolve, reject) => {
      appService.testsuites
        .updateTestSuiteExpireDate(testSuite.id, testSuite.expireDate)
        .then(data => {
          resolve(data)
          context.commit('getTests', data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  saveTestSuite(context, formData) {
    return new Promise((resolve, reject) => {
      appService.testsuites
        .saveTestSuite(formData)
        .then(data => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getTests(context, userId) {
    return new Promise((resolve, reject) => {
      appService.testsuites
        .getTests(userId)
        .then(data => {
          resolve(data)
          context.commit('getTests', data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteTest(context, inData) {
    return new Promise((resolve, reject) => {
      appService.testsuites
        .deleteTest(inData.userId, inData.testId)
        .then(data => {
          resolve(data)
          context.commit('deleteTest', inData.testId)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getPdfRequirements(context, inData) {
    return new Promise((resolve, reject) => {
      appService.testsuites
        .getPdfRequirements(inData.userId, inData.testId)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getPdfRequirementsTeamProfile(context, inData) {
    return new Promise((resolve, reject) => {
      appService.testsuites
        .getPdfRequirementsTeamProfile(inData.userId, inData.testIds)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  generatePdf(context, pdfSettings) {
    pdfSettings.isPreviewMode = !!(pdfSettings.isPreviewMode || false)
    pdfSettings.isExpertReport = !!(pdfSettings.isExpertReport || false)
    return new Promise((resolve, reject) => {
      appService.testsuites
        .generatePdf(pdfSettings)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  generateMultiPdf(context, pdfSettings) {
    pdfSettings.isPreviewMode = !!(pdfSettings.isPreviewMode || false)
    pdfSettings.isExpertReport = !!(pdfSettings.isExpertReport || false)
    return new Promise((resolve, reject) => {
      appService.testsuites
        .generateMultiPdf(pdfSettings)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTeamReportData(context, payload) {
    return new Promise((resolve, reject) => {
      appService.testsuites
        .getTeamReportData(payload)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  getTests(state, data) {
    state.tests = data
  },
  deleteTest(state, data) {
    state.tests = state.tests.filter(t => t.testId !== data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
